





import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

type Console = {
    debug: (... any) => void,
    info: (... any) => void,
    warn: (... any) => void,
    error: (... any) => void,
}

interface MonitorEventPayload {
    message: string
    source: string
    level: string

    // DEBUG events generally don't have a code.
    code?: string
    el?: HTMLElement

    context?: {[key: string]: any}
}

function prepareForConsole(e: MonitorEventPayload) {
    if (e.code) {
        return `[${e.source}] (${e.code}) ${e.message}`
    } else {
        return `[${e.source}] ${e.message}`
    }
}

function prepareForLogger(e: MonitorEventPayload) {
    return {
        message: prepareForConsole(e),
        level: e.level,
        code: e.code,
        source: e.source,
        context: e.context,
    }
}

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 * @changelog 4.5.0 Add debug and info levels with formatting.
 */
@Component
export default class JdsMonitorProvider extends Vue {
    @ActiveProvide('jds.monitor') monitorProvider: Vue|null = null;

    @Prop({default: null}) console!: Console|null;

    beforeMount () {
        this.monitorProvider = new Vue();

        // attach listeners
        this.monitorProvider.$on('debug', (e: MonitorEventPayload) => {
            if (this.console) this.console.debug(prepareForConsole(e));
            this.$emit('event', prepareForLogger(e))
        })
        this.monitorProvider.$on('info', (e: MonitorEventPayload) => {
            if (this.console) this.console.info(prepareForConsole(e));
            this.$emit('event', prepareForLogger(e))
        })
        this.monitorProvider.$on('warn', (e: MonitorEventPayload) => {
            if (this.console) {
                this.console.warn(prepareForConsole(e));
                if (e.el) this.console.warn(e.el)
            }
            this.$emit('event', prepareForLogger(e))
        })
        this.monitorProvider.$on('error', (e: MonitorEventPayload) => {
            if (this.console) {
                this.console.error(prepareForConsole(e));
                if (e.el) this.console.error(e.el)
            }
            this.$emit('event', prepareForLogger(e))
        })
    }
}
